// extracted by mini-css-extract-plugin
export default {"header__container":"Header_header__container__Nh+mk","header__logo-box":"Header_header__logo-box__Ithtv"};